import React, { useState } from 'react';
import SEOHelmet from '../components/SEOHelmet';

const editionImages = {
  '2025': [
    '491277031_675018581925695_5099277446400680643_n.jpg',
    '492315971_675018171925736_3612382132276398114_n.jpg',
    '493005900_674274018666818_809131706380507575_n.jpg',
    '493097220_675013211926232_7630663805108440042_n.jpg',
    '493103636_675013425259544_6235729655073863923_n.jpg',
    '493159939_674273648666855_493539611252240186_n.jpg',
    '493524526_675018198592400_1315618286519794258_n.jpg',
    '493562520_675018951925658_2060493397628835324_n.jpg',
    '493581488_674282218665998_5599405334403977779_n.jpg',
    '493924251_674273328666887_5721417239801650024_n.jpg',
    '494004214_674282261999327_2178644760997502360_n.jpg',
    '494005242_674273305333556_1833065854058523211_n.jpg',
    '494075051_675018355259051_7459268666068918352_n.jpg',
    '494098389_675013468592873_6580994018974354356_n.jpg',
    '494134412_674273872000166_5587700708357151890_n.jpg',
    '494210875_674273928666827_3258232026562904473_n.jpg',
    '494237495_675019021925651_220217076226198981_n.jpg',
    '494254820_675013078592912_2225415465861230177_n.jpg',
    '494268668_675018671925686_6397436608330066498_n.jpg',
    '494352458_674273332000220_3401651741566752260_n.jpg',
    '494434262_675018651925688_6832123059957037471_n.jpg',
    '494463560_674273615333525_2500753079678900877_n.jpg',
    '494465367_674273752000178_2886941089229200668_n.jpg',
    '494473526_675019195258967_7268750571525403160_n.jpg',
    '494510599_674273448666875_656804564774287898_n.jpg',
    '494512713_675017891925764_1906047321370724720_n.jpg',
    '494547169_674273772000176_4203407108538799686_n.jpg',
    '494592241_674273475333539_444916586253019270_n.jpg',
    '494606617_674273738666846_3590061936181144174_n.jpg',
    '494618112_674282241999329_800950374622330162_n.jpg',
    '494633278_674282051999348_6650794853404404883_n.jpg',
    '494639326_674273902000163_3544733017996656887_n.jpg',
    '494649544_675018768592343_8234759841866949791_n.jpg',
    '494649910_675018225259064_2245429809295109778_n.jpg',
    '494653303_675017828592437_6815722317780749256_n.jpg',
    '494709383_675019271925626_6190759632420582959_n.jpg',
    '494713512_675018788592341_5548101441576122547_n.jpg',
    '494721312_675013105259576_5688026627460596952_n.jpg',
    '494733106_675013135259573_8761657864425765612_n.jpg',
    '494769092_675013195259567_7366896776800257329_n.jpg',
    '494771046_675013441926209_965682853082776624_n.jpg',
    '494786910_674273595333527_1065946962680105217_n.jpg',
    '494998548_675018491925704_5250185442938341395_n.jpg',
    '494998744_674273478666872_2307604187284045875_n.jpg',
    '495098300_674282395332647_6038293152781631284_n.jpg',
    '495135231_674273528666867_8185183686146437502_n.jpg',
    '495143418_675019248592295_4207649838191148857_n.jpg',
    '495216431_675018741925679_1694199850367010862_n.jpg',
    '495216432_675018095259077_2587487535628380197_n.jpg',
    '495319833_674273982000155_4934035653433389150_n.jpg',
    '495338595_675013188592901_2124803491862933652_n.jpg',
    '495369088_675018995258987_3168655882940596784_n.jpg',
  ],
  '2024': [
    '479678867_616278207799733_486199342283865251_n.jpg',
    '480044684_616277844466436_3802933002975328318_n.jpg',
    '480050221_616277747799779_3241503065388745027_n.jpg',
    '480087661_616278084466412_8984729403499599545_n.jpg',
    '480090574_616277964466424_57808972593379648_n.jpg',
    '480096003_616277901133097_2253407136955583727_n.jpg',
    '480138879_616277894466431_4638850165457452973_n.jpg',
    '480151007_616278071133080_1665755709306484385_n.jpg',
    '480160114_616278097799744_2537065463584010937_n.jpg',
    '480176344_616277981133089_6929519113199064864_n.jpg',
    '480201922_616277781133109_2865112670172915093_n.jpg',
    '480204215_616278204466400_2315763750249959385_n.jpg',
    '480207304_616277784466442_4904387064034233742_n.jpg',
    '480237583_616278111133076_7943277432064945934_n.jpg',
    '480242541_616278031133084_3295460318896337561_n.jpg',
    '480312071_616277714466449_8245788297136507608_n.jpg',
    '480315428_616277881133099_1254288179388360607_n.jpg',
    '480318195_616277861133101_3771456756578504415_n.jpg',
  ],
  '2023': [
    '472795834_592464830181071_1485776517201204008_n.jpg',
    '472847016_592464823514405_8176087778957672348_n.jpg',
    '472862568_592464626847758_2340236777536033400_n.jpg',
    '472916695_592464623514425_624362054764083502_n.jpg',
    '472938807_592464706847750_3898557187760826087_n.jpg',
    '472947072_592464843514403_8950293360087003147_n.jpg',
    '472956214_592464826847738_278821182371299347_n.jpg',
    '472964316_592464886847732_7159537662831484747_n.jpg',
    '473023026_592464643514423_2517877321079434922_n.jpg',
    '473052622_592465030181051_8272169764598047952_n.jpg',
    '473054643_592464610181093_3038828670678441313_n.jpg',
    '473072718_592464740181080_2849095503848179021_n.jpg',
    '473072918_592464846847736_336738241127478419_n.jpg',
    '473098392_592464986847722_8398001660663673619_n.jpg',
    '473128924_592465070181047_6973628044013875892_n.jpg',
    '473145478_592464726847748_4603048759525691133_n.jpg',
    '473183667_592464806847740_4964781332912233174_n.jpg',
    '473191581_592464960181058_7131467830298005595_n.jpg',
    '473191884_592464993514388_90400757166723337_n.jpg',
    '473251743_592464990181055_461958467817765278_n.jpg',
    '473261282_592464640181090_5675603811053838910_n.jpg',
    '473274783_592464833514404_711348974933370208_n.jpg',
    '473284201_592464716847749_4443342586667944071_n.jpg',
    '473288208_592464700181084_295147526252618090_n.jpg',
    '473321804_592464720181082_4679038325516159260_n.jpg',
    '473539863_592464816847739_4267220498941007298_n.jpg',
  ],
};

const editions = [
  { year: '2025', folder: '2025' },
  { year: '2024', folder: '2024' },
  { year: '2023', folder: '2023' },
];

function PreviousEditions() {
  const [selectedEdition, setSelectedEdition] = useState(null);
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showTimeCard, setShowTimeCard] = useState(false);
  const [timeCardText, setTimeCardText] = useState('');

  const getYearsAgo = (year) => {
    const currentYear = new Date().getFullYear();
    const diff = currentYear - parseInt(year);
    if (diff === 0) return 'This Year!';
    if (diff === 1) return '1 Year Ago...';
    return `${diff} Years Ago...`;
  };

  const getYearsAgoBadge = (year) => {
    const currentYear = new Date().getFullYear();
    const diff = currentYear - parseInt(year);
    if (diff === 0) return 'This Year!';
    if (diff === 1) return '1 Year Ago';
    return `${diff} Years Ago`;
  };

  const handleEditionClick = (edition) => {
    if (selectedEdition?.year === edition.year) {
      setSelectedEdition(null);
      setImages([]);
      return;
    }

    // Show the SpongeBob time card animation first
    setTimeCardText(getYearsAgo(edition.year));
    setShowTimeCard(true);

    // After the animation, show the gallery
    setTimeout(() => {
      setShowTimeCard(false);
      setSelectedEdition(edition);
      setCurrentImageIndex(0);
      const fileNames = editionImages[edition.year] || [];
      setImages(fileNames.map(name => `${process.env.PUBLIC_URL}/previous-edition/${edition.folder}/${name}`));
    }, 2500);
  };

  const nextImage = () => {
    setCurrentImageIndex(prev => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(prev => (prev - 1 + images.length) % images.length);
  };

  return (
    <div>
      <SEOHelmet 
        title="Previous Editions - Code It Up Hackathon History"
        description="Explore previous editions of Code It Up hackathon. View photos and memories from past years (2023, 2024, 2025). See where the hackathon journey started."
        keywords="previous editions, code it up history, hackathon memories, past events, 2023, 2024, 2025"
        canonical="https://code-it-up-6.netlify.app/previous-editions"
      />
      <h1 style={{ textAlign: 'center' }}>PREVIOUS EDITIONS</h1>
      <p className="section-subtitle">
        A trip down memory lane!
      </p>

      {/* SpongeBob Time Card Overlay */}
      {showTimeCard && (
        <div className="time-card-overlay">
          <div className="time-card">
            <div className="time-card-flowers"></div>
            <h2 className="time-card-text">{timeCardText}</h2>
          </div>
        </div>
      )}

      <div className="editions-grid">
        {editions.map((edition) => (
          <div
            key={edition.year}
            className={`edition-card ${selectedEdition?.year === edition.year ? 'edition-active' : ''}`}
            onClick={() => handleEditionClick(edition)}
          >
            <div className="edition-tv">
              <div className="tv-screen">
                <span className="tv-year">{edition.year}</span>
              </div>
              <div className="tv-stand"></div>
            </div>
            <h3>Code It Up {edition.year}</h3>
          </div>
        ))}
      </div>

      {selectedEdition && (
        <div className="edition-gallery">
          <div className="gallery-board">
            <h2 className="gallery-title">
              Code It Up {selectedEdition.year}
              <span className="gallery-badge">{getYearsAgoBadge(selectedEdition.year)}</span>
            </h2>
            <div className="gallery-viewer">
              <button className="gallery-nav gallery-prev" onClick={prevImage}>
                &#9664;
              </button>
              <div className="gallery-image-container">
                <img
                  src={images[currentImageIndex]}
                  alt={`Edition ${selectedEdition.year} - ${currentImageIndex + 1}`}
                  className="gallery-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="gallery-placeholder" style={{ display: 'none' }}>
                  <p>No more photos!</p>
                  <p>Add images to:</p>
                  <p className="gallery-path">public/previous-edition/{selectedEdition.folder}/</p>
                </div>
              </div>
              <button className="gallery-nav gallery-next" onClick={nextImage}>
                &#9654;
              </button>
            </div>
            <div className="gallery-dots">
              {images.slice(0, 10).map((_, i) => (
                <span
                  key={i}
                  className={`gallery-dot ${i === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(i)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PreviousEditions;
